/**
 * @generated SignedSource<<81707b0a4ee0455bcaae6e531f239a91>>
 * @relayHash 3520cb3405bf5df677e699e027e38f90
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d5f6fe91ca3eeb49cf1444c59cbc5edd8accf64f7e09b2f84426f70b4a476e13

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraUpdateTimeTrackingFieldInput = {
  id: string;
  originalEstimate?: JiraEstimateInput | null | undefined;
  remainingEstimate?: JiraEstimateInput | null | undefined;
};
export type JiraEstimateInput = {
  timeInSeconds: AGG$Long;
};
export type lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_Mutation$variables = {
  input: JiraUpdateTimeTrackingFieldInput;
};
export type lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_Mutation$data = {
  readonly jira: {
    readonly updateTimeTrackingField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly id: string;
        readonly originalEstimate: {
          readonly timeInSeconds: AGG$Long | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_Mutation$rawResponse = {
  readonly jira: {
    readonly updateTimeTrackingField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly id: string;
        readonly originalEstimate: {
          readonly timeInSeconds: AGG$Long | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_Mutation = {
  rawResponse: lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_Mutation$rawResponse;
  response: lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_Mutation$data;
  variables: lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "JiraTimeTrackingFieldPayload",
        "kind": "LinkedField",
        "name": "updateTimeTrackingField",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          },
          {
            "concreteType": "JiraTimeTrackingField",
            "kind": "LinkedField",
            "name": "field",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "concreteType": "JiraEstimate",
                "kind": "LinkedField",
                "name": "originalEstimate",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "timeInSeconds"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "d5f6fe91ca3eeb49cf1444c59cbc5edd8accf64f7e09b2f84426f70b4a476e13",
    "metadata": {},
    "name": "lite_issueFieldOriginalEstimateInlineEditFull_OriginalEstimateInlineEditViewIsEditable_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "11dd5c5c4df23d2a67f16300cb79844d";

export default node;
